import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { FileText, Clock, CheckCircle2 } from 'lucide-react';

function StatCard({ label, value, Icon, iconColor }) {
  return (
    <Card data-testid={`stat-${label.toLowerCase().replace(/\s/g, '-')}`}>
      <CardContent className="pt-5 pb-5">
        <div className="flex items-center justify-between mb-3">
          <p className="text-xs font-medium text-muted-foreground uppercase tracking-wider">{label}</p>
          <Icon className={`h-5 w-5 ${iconColor}`} />
        </div>
        <p className="text-3xl font-bold">{value}</p>
      </CardContent>
    </Card>
  );
}

export default function ZohoDashboardStats({ stats }) {
  if (!stats) return null;

  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4" data-testid="dashboard-stats">
      <StatCard
        label="Total Submissions"
        value={stats.total_submissions || 0}
        Icon={FileText}
        iconColor="text-muted-foreground"
      />
      <StatCard
        label="Pending Review"
        value={stats.pending_review || 0}
        Icon={Clock}
        iconColor="text-amber-500"
      />
      <StatCard
        label="Approved"
        value={stats.approved || 0}
        Icon={CheckCircle2}
        iconColor="text-green-500"
      />
    </div>
  );
}
